import { downloadFile } from './downloadFile';

type Props = {
  text: string;
  filename: string;
};

const CONTENT_TYPES_BY_EXTENSION: Record<string, string> = {
  csv: 'text/csv;charset=utf-8;',
};

/**
 * Download text in a file by creating a `<a download>` and clicking it.
 */
export function downloadTextAsFile({ text, filename }: Props) {
  const extension = filename.split('.').pop();
  const contentType = CONTENT_TYPES_BY_EXTENSION[extension ?? ''] || 'text';

  const blob = new Blob([text], { type: contentType });
  const url = URL.createObjectURL(blob);

  downloadFile({ url, filename });
}
